/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeletePenaltyDetailsCommand } from '../../models/delete-penalty-details-command';
import { DeletePenaltyDetailsCommandResult } from '../../models/delete-penalty-details-command-result';

export interface ApiPenaltyDetailsDeletePenaltyDetailsDelete$Params {
      body?: DeletePenaltyDetailsCommand
}

export function apiPenaltyDetailsDeletePenaltyDetailsDelete(http: HttpClient, rootUrl: string, params?: ApiPenaltyDetailsDeletePenaltyDetailsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeletePenaltyDetailsCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiPenaltyDetailsDeletePenaltyDetailsDelete.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeletePenaltyDetailsCommandResult>;
    })
  );
}

apiPenaltyDetailsDeletePenaltyDetailsDelete.PATH = '/api/PenaltyDetails/DeletePenaltyDetails';
